export default "__VITE_ASSET__B57aaQru__"